import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    ILaunchDraftMapped,
    ILaunchDraftRaw,
    LaunchDraftRaw,
} from "../../types/draftApplication/launchDraftTypes"
import { getSchemaMapper } from "../singleApplication/getSchemaMapper"

export const draftApplicationMapper = {
    map: (response: unknown, draftId?: string): ILaunchDraftMapped => {
        // Validate the raw API response
        const resTyped = tsIoValidate<ILaunchDraftRaw>(
            LaunchDraftRaw,
            response,
            "Invalid raw launch draft response"
        )

        // Extract form steps and application spec from the raw spec
        const schemaMapperResult =
            getSchemaMapper.deriveSupportingInfoFromRawSpec(
                resTyped.rawApplicationSpec
            )

        return {
            // Include schema mapper properties
            rawApplicationSpec: resTyped.rawApplicationSpec,
            applicationStepIndexMap: schemaMapperResult.applicationStepIndexMap,
            formTitlesIndexMap: schemaMapperResult.formTitlesIndexMap,
            applicationForms: schemaMapperResult.applicationForms,

            // Include draft-specific data
            fixedInputs: resTyped.fixedInputs,
            formData: resTyped.formData,
            supplementingInfo: resTyped.supplementingInfo,
            lcts: resTyped.lcts || [],
            completionStatus: resTyped.completionStatus,
            jurisdiction: resTyped.jurisdiction || "GB",
            draftId,
        }
    },
}
